import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, postRequest, putRequest } from '../config/axios-config';


const getInfluencerAffiliateDetails = (influencerId, queryParams) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getInfluencerAffiliateDetails +
          '/' +
          influencerId,
        queryParams
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createCoupon = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createCoupon,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateCouponCode = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateCouponCode,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteCouponCode = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.deleteCouponCode,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createBulkAffiliate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createBulkAffiliate,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const bulkMoveToSathiCampaign = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.bulkMoveToSathiCampaign,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateBulkAffiliateCommission = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateBulkAffiliateCommission,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createAffiliate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createAffiliate,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createBulkCoupon = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createBulkCoupon,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateBulkCoupon = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateBulkCoupon,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getDiscountTemplates = (campaignId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getDiscountTemplates,
        campaignId ? { campaignId } : undefined
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createDiscountTemplate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createDiscountTemplate,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateDiscountTemplate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateDiscountTemplate,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteDiscountTemplate = (templateId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.deleteDiscountTemplate +
          '/' +
          templateId
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getProducts = (query) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getProducts + '?title=' + query
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getProductsList = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getProductsList,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getTotalSalesGrowthStats = (duration, startDate, endDate) => {
  return new Promise(async (resolve, reject) => {
    try {
      let queryParams = {
        duration,
      };
      if (startDate) queryParams.startDate = startDate;
      if (endDate) queryParams.endDate = endDate;

      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getTotalSalesGrowthStats,
          queryParams
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getOrderList = (influencerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getOrderList + '/' + influencerId
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateRefCode = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateRefCode,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createMultiProductOrder = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createMultiProductOrder,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getFrequentlyShippedProducts = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getFrequentlyShippedProducts
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const pushBulkOrderToQueue = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.pushBulkOrderToQueue,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createAffiliateLink = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createAffiliateLink,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};
const updateAffiliateLink = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateAffiliateLink,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteAffiliateLink = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.deleteAffiliateLink,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const resendProducts = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.resendProducts,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const checkIfCustomCouponExists = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.checkIfCustomCouponExists,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getSathiAffiliateStatus = (influencerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getSathiAffiliateStatus +
          '/' +
          influencerId
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const linkSaralAffiliateToSathi = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.linkSaralAffiliateToSathi,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getAllSathiCampaigns = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllSathiCampaigns
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const moveSathiAffiliateCampaign = (influencerId, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.moveSathiAffiliateCampaign +
          '/' +
          influencerId +
          '/move-campaign',
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getSathiMagicLink = (influencerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getSathiMagicLink +
          '/' +
          influencerId +
          '/magic-link'
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export {
  getInfluencerAffiliateDetails,
  createAffiliate,
  createCoupon,
  createBulkAffiliate,
  bulkMoveToSathiCampaign,
  createBulkCoupon,
  updateBulkCoupon,
  getDiscountTemplates,
  createDiscountTemplate,
  updateDiscountTemplate,
  deleteDiscountTemplate,
  getProducts,
  getProductsList,
  getTotalSalesGrowthStats,
  getOrderList,
  updateRefCode,
  createMultiProductOrder,
  pushBulkOrderToQueue,
  createAffiliateLink,
  updateAffiliateLink,
  updateCouponCode,
  deleteCouponCode,
  updateBulkAffiliateCommission,
  deleteAffiliateLink,
  resendProducts,
  getFrequentlyShippedProducts,
  checkIfCustomCouponExists,
  getSathiAffiliateStatus,
  linkSaralAffiliateToSathi,
  getAllSathiCampaigns,
  moveSathiAffiliateCampaign,
  getSathiMagicLink,
};
